import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

DialogVoucherBatchAddView.propTypes = {
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
    item: PropTypes.object,
    agencyId: PropTypes.string,
};

function DialogVoucherBatchAddView({
    onCancel,
    onDone,
    item,
    agencyId,
}) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [batchType, setBatchType] = useState(AgencyConstants.VoucherBatchType.SELF_CLAIM);
    const [name, setName] = useState('');
    const [identityType, setIdentityType] = useState(AgencyConstants.VoucherIdentityType.ANY);
    const [selectedAgency, setSelectedAgency] = useState(null);
    const [type, setType] = useState(AgencyConstants.VoucherType.MONEY);
    const [value, setValue] = useState(null);
    const [duration, setDuration] = useState(null);
    const [expirationDate, setExpirationDate] = useState(null);
    const [quantity, setQuantity] = useState(null);
    const [useLimit, setUseLimit] = useState(null);
    const [prefix, setPrefix] = useState('');
    const [description, setDescription] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const selectFilePathList = useRef([]);
    const [allFiles, setAllFiles] = useState([]);
    const [readyToValidDate, setReadyToValidDate] = useState(false);
    const isEmptyNumber = (input) =>
        input === null || input === undefined || input === '';
    const isNameValid = !!name?.trim();
    const isValueValid = !isEmptyNumber(value) && Number(value) > 0;
    const isDurationValid = !isEmptyNumber(duration);
    const isQuantityValid = !isEmptyNumber(quantity) && Number(quantity) > 0;
    useEffect(() => {
        if (Utils.isValid(item)) {
            setBatchType(item?.batchType);
            setName(item?.name);
            setIdentityType(
                item?.batchType === AgencyConstants.VoucherBatchType.PARTNER
                    && item?.identityType === AgencyConstants.VoucherIdentityType.ANY
                    ? AgencyConstants.VoucherIdentityType.DRIVER
                    : item?.identityType
            );
            setType(item?.type);
            setValue(item?.value);
            setDuration(item?.duration);
            setExpirationDate(item?.expirationDate ? Utils.formatDateTimeToString(item?.expirationDate, 'YYYY-MM-DD') : null);
            setQuantity(item?.quantity);
            setUseLimit(item?.useLimit);
            setPrefix(item?.prefix);
            setDescription(item?.description);
            setAllFiles(item?.attachedFiles ?? []);
        }
    }, [item]);
    useEffect(() => {
        if (!!agencyId) {
            setBatchType(AgencyConstants.VoucherBatchType.PARTNER);
            setIdentityType((prev) =>
                prev === AgencyConstants.VoucherIdentityType.ANY
                    ? AgencyConstants.VoucherIdentityType.DRIVER
                    : prev
            );
        }
    }, [agencyId])
    useEffect(() => {
        let id;
        if (!!item) {
            id = item?.agencyId;
        } else if (!!agencyId) {
            id = agencyId;
        }
        if (Utils.isValid(id)) {
            AgencyHelper.API.requestAgencyDetail(id).then(
                (row) => {
                    if (row) {
                        setSelectedAgency({
                            id: row?.agencyId,
                            name: row?.name,
                            item: row,
                        });
                    }
                }
            );
        }
    }, [item, agencyId]);

    const dropdownAgencyEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="agencyId"
                name="agencyId"
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
              ${(batchType !== AgencyConstants.VoucherBatchType.PARTNER || !!agencyId || !!item) ? 'disabled' : ''}
              ${readyToValidDate && batchType === AgencyConstants.VoucherBatchType.PARTNER && !selectedAgency?.id ? 'border-danger' : ''}
              `}
                        type="button"
                    >
                        {selectedAgency
                            ? selectedAgency?.name
                            : batchType !== AgencyConstants.VoucherBatchType.PARTNER ? 'Nhà điều hành' : 'Chọn đối tác'}
                    </button>
                }
                selectedValue={selectedAgency}
                subTitleType="email"
                dropdownMenuItems={[]}
                getSubItems={async (item) => {
                    return AgencyHelper.API.requestGetAgencyList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                        status: 'NORMAL',
                        role: AgencyConstants.AgencyRole.VOUCHER_PARTNER,
                    }).then((data) => {
                        return {
                            values: data.agencies?.map((row) => ({
                                id: row?.agencyId,
                                name: row?.name,
                                item: row,
                                email: row?.email,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedAgency(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                ignoreConfirmClick={true}
                defaultValue={{
                    name: 'VOUCHER_PARTNER',
                    role: 'VOUCHER_PARTNER',
                }}
                defaultItem={null}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedAgency(null);
                        })}
                    </div>
                }
                disabled={batchType !== AgencyConstants.VoucherBatchType.PARTNER || !!agencyId || !!item}
            />
        );
    }, [selectedAgency, readyToValidDate, batchType, agencyId]);

    const identityTypeOptions = useMemo(() => {
        if (batchType === AgencyConstants.VoucherBatchType.PARTNER) {
            return AgencyHelper.Data.agencyVoucherIdentityTypeOptions;
        } else {
            return AgencyHelper.Data.voucherIdentityTypeOptions;
        }
    }, [batchType])

    // MARK: ---- FUNCTIONS ----
    const handleFilesChanged = (e) => {
        const newFiles = Array.from(e.target.files || []);

        const validFiles = newFiles.filter((file) => {
            if (file.name.length > 128) {
                ToastHelper.showError(`Tên file quá dài! Tối đa cho phép 128 ký tự.`);
                return false;
            }
            return true;
        });

        if (validFiles.length === 0) return;

        setSelectedFiles((prev) => [...prev, ...validFiles]);
        setAllFiles((prev) => [...prev, ...validFiles]);
    };
    const handleRemoveFile = (file) => {
        if (file instanceof File) {
            const tmpFiles = selectedFiles.filter((item) => item.lastModified !== file?.lastModified);
            setSelectedFiles(tmpFiles);
        }

        let newAllFiles = [...allFiles];
        if (typeof file === 'string') {
            newAllFiles = _.filter(allFiles, (item) => item !== file);
        }
        if (file instanceof File) {
            newAllFiles = _.filter(allFiles, (item) => item.lastModified !== file?.lastModified);
        }
        setAllFiles(newAllFiles);
    };
    async function processSelectedFiles(files) {
        for (const file of files) {
            const path = await uploadAsyncFunction(file);
            selectFilePathList.current?.push(path);
        }
    }
    async function uploadAsyncFunction(file) {
        return new Promise((resolve) => {
            if (file instanceof File) {
                miscHelper.callApiUploadFile(file).then((mediaList) => {
                    if (_.isArray(mediaList) && mediaList.length > 0) {
                        const firstMedia = _.first(mediaList);
                        const relativePath = firstMedia?.relativePath;
                        if (relativePath) {
                            resolve(relativePath);
                        } else {
                            resolve(null);
                        }
                    } else {
                        resolve(null);
                    }
                });
            } else {
                resolve(file);
            }
        });
    }

    const handleConfirm = async () => {
        setReadyToValidDate(true);
        if (
            !batchType ||
            !isNameValid ||
            !identityType ||
            !type ||
            !isValueValid ||
            !isQuantityValid ||
            !isDurationValid
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (batchType === AgencyConstants.VoucherBatchType.PARTNER && !selectedAgency?.id) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (value && value <= 0) {
            ToastHelper.showError('Giá trị voucher phải lớn 0');
            return;
        }

        if (!_.isEmpty(selectedFiles)) {
            selectFilePathList.current = [];
            await processSelectedFiles(selectedFiles);
        }
        setAllFiles([
            ..._.filter(allFiles, (item) => typeof item === 'string'),
            ...selectFilePathList.current,
        ]);
        const attachedFiles = [
            ..._.filter(allFiles, (item) => typeof item === 'string'),
            ...selectFilePathList.current,
        ];

        const params = {
            batchType,
            name,
            identityType,
            type,
            value,
            quantity,
            agencyId: batchType === AgencyConstants.VoucherBatchType.PARTNER
                ? selectedAgency?.id ?? null
                : null,
            attachedFiles,
            duration: duration ?? null,
            expirationDate: expirationDate ?? null,
            useLimit: useLimit ?? null,
            prefix,
            description,
        };
        setLoading(true);
        if (!!item) {
            const res = await AgencyHelper.API.requestUpdateVoucherBatch(item.voucherBatchId, params);
            if (res && _.isBoolean(res)) {
                ToastHelper.showSuccess('Cập nhật lô voucher thành công');
                if (onDone) onDone();
            } else {
                ToastHelper.showError(res);
            }
        } else {
            const res = await AgencyHelper.API.requestAddVoucherBatch(params);
            if (res && _.isBoolean(res)) {
                ToastHelper.showSuccess('Cập nhật lô voucher thành công');
                if (onDone) onDone();
            } else {
                ToastHelper.showError(res);
            }
        }
        setLoading(false);
    };

    return (
        <div className="">
            <div className="row m-0 p-0 px-2 mt-4">
                {/* hinh thuc phat hanh */}
                <div className="col-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hình thức phát hành', true)}
                    <KTBSDropdown
                        name="batchType"
                        toggleElement={
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                    ${(!!agencyId || !!item) ? 'disabled' : ''}
                                    ${readyToValidDate && !batchType ? 'border-danger' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    AgencyHelper.Data.voucherAddBatchTypeOptions,
                                    (item) => item.value === batchType
                                )?.name ?? 'Chọn hình thức phát hành'}
                            </button>
                        }
                        selectedValue={batchType}
                        dropdownMenuItems={AgencyHelper.Data.voucherAddBatchTypeOptions}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            setBatchType(value);
                            if (value !== AgencyConstants.VoucherBatchType.PARTNER) {
                                setSelectedAgency(null);
                            }
                            if (value === AgencyConstants.VoucherBatchType.SELF_CLAIM) {
                                setIdentityType(AgencyConstants.VoucherIdentityType.ANY);
                            } else if (value === AgencyConstants.VoucherBatchType.PARTNER) {
                                setIdentityType(AgencyConstants.VoucherIdentityType.DRIVER);
                            }
                        }}
                        isDropdownForm={true}
                        disabled={!!agencyId || !!item}
                    />
                </div>
                {/* ten lo voucher */}
                <div className="col-12 mb-4 px-2">
                    <div className='d-flex gap-2 align-items-center'>
                        {UIHelper.buildFormLabel('Tên lô voucher', true)}
                    </div>
                    <KTFormInput
                        name="name"
                        placeholder="Nhập tên lô voucher"
                        type={KTFormInputType.text}
                        value={name}
                        onChange={(value) => setName(value)}
                        enableCheckValid={readyToValidDate}
                        isTouched={readyToValidDate}
                        isValid={isNameValid}
                        feedbackText="Vui lòng nhập tên lô voucher"
                    />
                </div>
                {/* doi tuong nhan voucher */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đối tượng nhận voucher', true)}
                    <KTBSDropdown
                        name="identityType"
                        toggleElement={
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                                    ${batchType === AgencyConstants.VoucherBatchType.SELF_CLAIM ? 'disabled' : ''}
                                    ${readyToValidDate && !identityType ? 'border-danger' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    identityTypeOptions,
                                    (item) => item.value === identityType
                                )?.name ?? 'Chọn đối tượng nhận voucher'}
                            </button>
                        }
                        selectedValue={identityType}
                        dropdownMenuItems={identityTypeOptions}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            setIdentityType(value);
                        }}
                        isDropdownForm={true}
                        disabled={batchType === AgencyConstants.VoucherBatchType.SELF_CLAIM}
                    />
                </div>
                {/* ten doi tac */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Tên đối tác', true)}
                    {dropdownAgencyEl}
                </div>
                {/* loai voucher */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Loại voucher', true)}
                    <KTBSDropdown
                        name="type"
                        toggleElement={
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between disabled
                                    ${readyToValidDate && !type ? 'border-danger' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    AgencyHelper.Data.voucherTypeOptions,
                                    (item) => item.value === type
                                )?.name ?? 'Chọn loại voucher'}
                            </button>
                        }
                        selectedValue={type}
                        dropdownMenuItems={AgencyHelper.Data.voucherTypeOptions}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            setType(value);
                        }}
                        isDropdownForm={true}
                        disabled={true}
                    />
                </div>
                {/* gia tri voucher */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Giá trị voucher', true)}
                    <KTFormInput
                        name="value"
                        placeholder="Nhập số"
                        type={KTFormInputType.currency}
                        value={value}
                        onChange={(value) => setValue(value)}
                        currencyAutoFillZero={false}
                        enableCheckValid={readyToValidDate}
                        isTouched={readyToValidDate}
                        isValid={isValueValid}
                        feedbackText="Vui lòng nhập giá trị voucher lớn hơn 0"
                    />
                </div>
                {/* so ngay hieu luc tu luc phat hanh */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Số ngày hiệu lực từ lúc phát hành', true)}
                    <KTFormInput
                        name="duration"
                        placeholder="Nhập số"
                        type={KTFormInputType.currency}
                        value={duration}
                        onChange={(value) => setDuration(value)}
                        currencyAutoFillZero={false}
                        enableCheckValid={readyToValidDate}
                        isTouched={readyToValidDate}
                        isValid={isDurationValid}
                        feedbackText="Vui lòng nhập số ngày hiệu lực"
                        unit='Ngày'
                    />
                </div>
                {/* han phat hanh */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hạn phát hành')}
                    <KTFormInput
                        name="expirationDate"
                        placeholder="Chọn hạn phát hành"
                        type={KTFormInputType.date}
                        value={expirationDate}
                        onChange={(value) => setExpirationDate(value)}
                        minTime={moment()}
                    />
                </div>
                {/* so luong voucher */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Số lượng voucher', true)}
                    <KTFormInput
                        name="quantity"
                        placeholder="Nhập số"
                        type={KTFormInputType.currency}
                        value={quantity}
                        onChange={(value) => setQuantity(value)}
                        currencyAutoFillZero={false}
                        enableCheckValid={readyToValidDate}
                        isTouched={readyToValidDate}
                        isValid={isQuantityValid}
                        feedbackText="Vui lòng nhập số lượng voucher lớn hơn 0"
                        unit='Cái'
                    />
                </div>
                {/* so luot su dung toi da */}
                <div className="col-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Số lượt sử dụng tối đa')}
                    <KTFormInput
                        name="useLimit"
                        placeholder="Nhập số"
                        type={KTFormInputType.currency}
                        value={useLimit}
                        onChange={(value) => setUseLimit(value)}
                        currencyAutoFillZero={false}
                        unit='Lượt'
                    />
                </div>
                {/* tien to */}
                <div className="col-12 mb-4 px-2">
                    <div className='d-flex gap-2 align-items-center'>
                        {UIHelper.buildFormLabel('Tiền tố', false, false)}
                        <KTTooltip
                            textHeader='Tiền tố'
                            text="Voucher tạo từ lô voucher có tiền tố sẽ được tự động sinh mã sử dụng theo cấu trúc: [Tiền tố]-[Mã tự sinh 6 ký tự] (ví dụ: NGUOIMOI-89F12D)"
                        >
                            <i className="fa-regular fa-circle-info" style={{ color: AppColors.info }} />
                        </KTTooltip>
                    </div>
                    <KTFormInput
                        name="prefix"
                        placeholder="Nhập tiền tố"
                        type={KTFormInputType.text}
                        value={prefix}
                        onChange={(value) => setPrefix(value)}
                    />
                </div>
                {/* mo ta */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Mô tả')}
                    <KTFormTextArea
                        placeholder="Nhập mô tả"
                        rows={3}
                        name="description"
                        value={description}
                        onChange={(value) => {
                            setDescription(value);
                        }}
                        enableCheckValid={false}
                    />
                </div>
                {/* file dinh kem */}
                <div className="mb-2">
                    {UIHelper.buildFormLabel('Tải lên tệp tin đính kèm', false, false)}
                    <div>
                        {/* danh sach file dang duoc chon */}
                        {!_.isEmpty(allFiles) && (
                            <div className="row m-0 p-0">
                                {allFiles.map((item, index) => {
                                    return (
                                        <div className="p-0 col-4 mb-2 p-2" key={item?.lastModified ?? item ?? index}>
                                            <ImageView
                                                name={item?.lastModified ?? item ?? index}
                                                path={_.isString(item) ? item : item?.name}
                                                onRemove={() => {
                                                    handleRemoveFile(item);
                                                }}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        <div className="d-flex">
                            <label className="">
                                {UIHelper.buildNegativeButton(
                                    'Thêm tập tin',
                                    () => { },
                                    <i className="fa-regular fa-upload" />
                                )}
                                <input
                                    type="file"
                                    accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                                    onChange={handleFilesChanged}
                                    multiple
                                    hidden
                                    onClick={(e) => {
                                        e.target.value = null;
                                    }}
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            {/* footer */}
            <div
                className="d-flex align-items-center gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
                {UIHelper.buildGreenButton(
                    !Utils.isValid(item) ? 'Thêm lô voucher' : 'Cập nhật',
                    handleConfirm,
                    null,
                    true,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogVoucherBatchAddView;
